import BaseNetwork from "@/lib/classes/BaseNetwork";
import { derivePubkeyFromXpub } from "@/lib/helpers/derive";
import { payments } from "bitcoinjs-lib";
import { encodeCashAddress } from "ecashaddrjs";

class BCH extends BaseNetwork {
  constructor(xpub: string) {
    super("BCH", xpub);
  }

  getAddress(index: number, derivationPath: number[], xpub: string): string {
    const derivedPubkey = derivePubkeyFromXpub(xpub, [
      ...derivationPath,
      index,
    ]);

    const { hash } = payments.p2pkh({
      pubkey: Buffer.from(derivedPubkey.compressed, "hex"),
    });
    if (!hash) throw new Error("Could not generate BCH address");

    const cashAddr = encodeCashAddress("bitcoincash", "p2pkh", hash);

    if (!cashAddr) throw new Error("Could not generate cashaddress");

    return cashAddr.replace("bitcoincash:", "");
  }
}

export default BCH;
